import { render, staticRenderFns } from "./ConsumerProfileCard.vue?vue&type=template&id=5b8237b6&"
import script from "./ConsumerProfileCard.vue?vue&type=script&lang=js&"
export * from "./ConsumerProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports